module.exports = __webpack_public_path__ + "static/media/ALUR.a901cade.png";